/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('taxpayers', {
                parent: 'app',
                url: '/taxpayer?page&size',
                params: {
                    page: "0",
                    size: "10"
                },
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/taxpayer/taxpayers.html',
                        controller: 'taxpayerCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxpayer']);
                            }],
                            taxpayers: ['taxpayerService','$stateParams', function(taxpayerService, $stateParams){
                                return taxpayerService.getPageTaxpayers($stateParams.page, $stateParams.size);
                            }]
                        }
                    }
                }
            })
            .state('taxpayerNew', {
                parent: 'app',
                url: '/taxpayer/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/taxpayer/newTaxpayer.html',
                        controller: 'newTaxpayerCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxpayer']);
                            }]
                        }
                    }
                }
            })
            .state('taxpayerEdit', {
                parent: 'app',
                url: '/taxpayer/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views:{
                    'main@':{
                        templateUrl: 'app/admin/finance/taxpayer/editTaxpayer.html',
                        controller: 'editTaxpayerCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxpayer']);
                            }],
                            'taxpayer': ['taxpayerService', '$stateParams', function(taxpayerService, $stateParams) {
                                return taxpayerService.getTaxpayer($stateParams.id);
                            }],
                        }
                    }
                }
            })
            .state('taxpayerDelete', {
                parent: 'taxpayers',
                url: '/taxpayer/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/finance/taxpayer/deleteTaxpayer.html',
                        controller: 'deleteTaxpayerController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['taxpayer']);
                            }]
                        }
                    }).result.then(function() {
                        $state.go('taxpayers', null, { reload: true });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });
    }
})();
